<template>
  <div class="page" :class="{'page__has-bar': !readonly}">
    <div class="weui-gallery" style="display: block;" v-if="showPreview" @click="showPreview = false">
      <span class="weui-gallery__img" :style="{backgroundImage: 'url(' + form.main.pr_picture + ')'}"></span>
    </div>
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">产品编号</label>
            <em class="weui-form-preview__value">{{form.main.pr_code}}</em>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.pr_picture">
            <label class="weui-form-preview__label">产品图片</label>
            <img style="max-width: 240px; max-height: 240px; object-fit: contain;" :src="form.main.pr_picture" @click="showPreview = true">
          </div>
        </div>

        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="pr_detail">
            <label class="weui-form-preview__label">{{customLabel.pr_detail || "产品名称"}}</label>
            <em class="weui-form-preview__value">{{form.main.pr_detail}}</em>
          </div>
          <div class="weui-form-preview__item" slot="pr_brand">
            <label class="weui-form-preview__label">{{customLabel.pr_brand || "品牌"}}</label>
            <span class="weui-form-preview__value">{{form.main.pr_brand}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_orispeccode">
            <label class="weui-form-preview__label">{{customLabel.pr_orispeccode || "型号"}}</label>
            <span class="weui-form-preview__value">{{form.main.pr_orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_spec">
            <label class="weui-form-preview__label">{{customLabel.pr_spec || "规格"}}</label>
            <span class="weui-form-preview__value">{{form.main.pr_spec}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_kind">
            <label class="weui-form-preview__label">{{customLabel.pr_kind || "类型"}}</label>
            <span class="weui-form-preview__value">{{form.main.pr_kind}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_manutype">
            <label class="weui-form-preview__label">{{customLabel.pr_manutype || "生产类型"}}</label>
            <span class="weui-form-preview__value">{{pr_manutype}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_unit">
            <label class="weui-form-preview__label">{{customLabel.pr_unit || "单位"}}</label>
            <span class="weui-form-preview__value">{{form.main.pr_unit}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_unit_extra" v-if="form.main.pr_unit_extra">
            <label class="weui-form-preview__label">{{customLabel.pr_unit_extra || "辅助单位"}}</label>
            <span class="weui-form-preview__value">{{form.main.pr_unit_extra}}</span>
          </div>
          <div class="weui-form-preview__item" slot="单位换算" v-if="form.main.pr_unit_extra">
            <label class="weui-form-preview__label">{{"单位换算"}}</label>
            <span class="weui-form-preview__value">
              {{ form.main.pr_numerator }}
              {{ form.main.pr_unit_extra }}
              =
              {{ form.main.pr_denominator }}
              {{ form.main.pr_unit }}
            </span>
          </div>
        </custom-layout>

        <custom-layout class="weui-form-preview__bd" v-if="opener != 'share'" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="pr_vendname">
            <label class="weui-form-preview__label">{{customLabel.pr_vendname || "供应商"}}</label>
            <em class="weui-form-preview__value">{{form.main.pr_vendname}}</em>
          </div>
          <div class="weui-form-preview__item" slot="pr_leadtime">
            <label class="weui-form-preview__label">{{customLabel.pr_leadtime || "采购提前期"}}</label>
            <span class="weui-form-preview__value">{{form.main.pr_leadtime}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_zxbzs">
            <label class="weui-form-preview__label">{{customLabel.pr_zxbzs || "最小包装数"}}</label>
            <span class="weui-form-preview__value">{{form.main.pr_zxbzs}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_purcprice">
            <label class="weui-form-preview__label">{{customLabel.pr_purcprice || "最新购价(元)"}}</label>
            <span class="weui-form-preview__value">{{form.main.pr_purcprice}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_standardprice">
            <label class="weui-form-preview__label">{{customLabel.pr_standardprice || "标准定价(元)"}}</label>
            <span class="weui-form-preview__value">{{form.main.pr_standardprice}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_saleprice">
            <label class="weui-form-preview__label">{{customLabel.pr_saleprice || "最新售价(元)"}}</label>
            <span class="weui-form-preview__value">{{form.main.pr_saleprice}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_whname">
            <label class="weui-form-preview__label">{{customLabel.pr_whname || "默认仓库"}}</label>
            <span class="weui-form-preview__value">{{form.main.pr_whname}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_safetystock">
            <label class="weui-form-preview__label">{{customLabel.pr_safetystock || "安全库存"}}</label>
            <span class="weui-form-preview__value">{{form.main.pr_safetystock}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_weight" :hidden="!form.main.pr_weight">
            <label class="weui-form-preview__label">{{customLabel.pr_weight || "重"}}</label>
            <span class="weui-form-preview__value">{{form.main.pr_weight}} kg</span>
          </div>
          <!-- <div class="weui-form-preview__item" slot="par_unit1" :hidden="!form.main.par_unit1">
            <label class="weui-form-preview__label">{{customLabel.par_unit1 || "单重单位"}}</label>
            <span class="weui-form-preview__value">{{form.main.par_unit1}}</span>
          </div> -->
          <div class="weui-form-preview__item" slot="pr_length" :hidden="!form.main.pr_length">
            <label class="weui-form-preview__label">{{customLabel.pr_length || "长"}}</label>
            <span class="weui-form-preview__value">{{form.main.pr_length}} cm</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_width" :hidden="!form.main.pr_width">
            <label class="weui-form-preview__label">{{customLabel.pr_width || "宽"}}</label>
            <span class="weui-form-preview__value">{{form.main.pr_width}} cm</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_height" :hidden="!form.main.pr_height">
            <label class="weui-form-preview__label">{{customLabel.pr_height || "厚"}}</label>
            <span class="weui-form-preview__value">{{form.main.pr_height}} cm</span>
          </div>
          <div class="weui-form-preview__item" slot="par_packingqty" :hidden="!form.main.par_packingqty">
            <label class="weui-form-preview__label">{{customLabel.par_packingqty || "包装规格"}}</label>
            <span class="weui-form-preview__value">{{form.main.par_packingqty}}</span>
          </div>
          <div class="weui-form-preview__item" slot="par_unit2" :hidden="!form.main.par_unit2">
            <label class="weui-form-preview__label">{{customLabel.par_unit2 || "包装单位"}}</label>
            <span class="weui-form-preview__value">{{form.main.par_unit2}}</span>
          </div>
          <div class="weui-form-preview__item" slot="par_outerboxgw" :hidden="!form.main.par_outerboxgw">
            <label class="weui-form-preview__label">{{customLabel.par_outerboxgw || "毛重(kg)"}}</label>
            <span class="weui-form-preview__value">{{form.main.par_outerboxgw}}</span>
          </div>
          <div class="weui-form-preview__item" slot="par_outerboxnw" :hidden="!form.main.par_outerboxnw">
            <label class="weui-form-preview__label">{{customLabel.par_outerboxnw || "净重(kg)"}}</label>
            <span class="weui-form-preview__value">{{form.main.par_outerboxnw}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_remark" :hidden="!form.main.pr_remark">
            <label class="weui-form-preview__label">{{customLabel.pr_remark || "备注"}}</label>
            <span class="weui-form-preview__value">{{form.main.pr_remark}}</span>
          </div>
          <custom-field :readOnly="true" :label="customLabel.pr_text1 || '自定义字段1'"
          v-model="form.main.pr_text1" slot="pr_text1" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pr_text2 || '自定义字段2'"
          v-model="form.main.pr_text2" slot="pr_text2" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pr_text3 || '自定义字段3'"
          v-model="form.main.pr_text3" slot="pr_text3" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pr_text4 || '自定义字段4'"
          v-model="form.main.pr_text4" slot="pr_text4" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pr_text5 || '自定义字段5'"
          v-model="form.main.pr_text5" slot="pr_text5" hidden="true" />
        </custom-layout>
      </div>

      <file-list v-model="form.main.pr_attach" />
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/document/product_edit?id='+form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
      >编辑</router-link>
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_unaudit"
        >反审</a
      >
      <a
        href="javascript:;"
        v-if="form.main.pr_statuscode=='ENABLE'"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_enable(0)"
      >禁用</a>
      <a
        href="javascript:;"
        v-if="form.main.pr_statuscode!='ENABLE'"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_enable(1)"
      >启用</a>
      <a href="javascript:;" v-if="editable" class="weui-dialog__btn weui-dialog__btn_default" @click="f_remove">删除</a>
      <router-link
        :to="'/production/bom_composite/'+form.main.pr_code"
        v-if="isMakeApp"
        class="weui-dialog__btn weui-dialog__btn_default"
      >查询</router-link>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import process from "@/mixins/process.js";
import CustomField from "@/components/field/CustomField.vue";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList,
    CustomField
  },
  data() {
    return {
      baseUrl: "/api/document/product",
      codeField: "pr_code",
      statusField: "pr_auditstatuscode",
      caller: "Product",
      xtype:'document-product-formpanel',
      showPreview: false
    };
  },
  computed: {
    pr_manutype() {
      let pr_manutype = this.form.main.pr_manutype

      const datas = {
        "MAKE": "自制",
        "OSMAKE": "委外",
        "PURCHASE": "外购",
        "MAKECUT": "分切",
        "CUSPROVIDE": "客供",
        "NOT": "无"
      }

      return datas[pr_manutype]
    }
  }
};
</script>